import { useMsal } from "@azure/msal-react"
import { useEffect } from "react"
import { postMessageToRuntime } from "../../Components/Helpers/Runtime/runtime";

function AccessStorage() {

    const context = useMsal();

    useEffect(() => {
        window.addEventListener('message', handleMessage)
        return () => {
            window.removeEventListener('message', handleMessage)
        }
    }, [])

    function handleMessage(event) {
        if (event.origin === process.env.REACT_APP_RUNTIME_URL) {
            try {
                const data = JSON.parse(event.data);
                if (data.type === "REFRESH_TOKEN") {
                    localStorage.setItem('accessToken', data.token)
                    postMessageToRuntime(JSON.stringify({
                        status: "Success"
                    }))
                } else if (data.type === "LOGOUT") {
                    const account = context.accounts[0];
                    localStorage.clear();
                    if (account) {
                        context.instance.logoutRedirect({
                            account: context.instance.getAccountByHomeId(account.homeAccountId)
                        })
                    }
                    postMessageToRuntime(JSON.stringify({
                        status: "Success"
                    }))
                }
            } catch (error) {
                console.error(error);
                postMessageToRuntime(JSON.stringify({
                    status: "Failure",
                    error: error.message
                }))
            }
        }
    }

    return (
        <div>
            <h1>Access Storage</h1>
        </div>
    )
}

export default AccessStorage